import React, { useState } from "react";
import NewChecklist from "../component/NewChecklist";
import {
  addCheckListService,
  editCheckListService,
} from "../services/CheckListService";
import { Apinames } from "../utils/Apiname";
import { Modal, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NewChecklistScreen = () => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();
  const checklistData = location.state;
  console.log("checklistData==>", checklistData);

  const handleSubmit = async (values: any) => {
    console.log("Form values submitted:", values);

    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("description", values.description);
    formData.append("duaDateTime", values.duaDateTime);
    formData.append("priority", values.priority);
    if (checklistData?.edit) {
      formData.append("id", checklistData?.id);
    }
    if (!checklistData?.isTemplate) {
      formData.append("assignedTo", "ALL");
    }

    formData.append("emailReminder", values.emailReminder.toString());
    formData.append("isTemplate", checklistData?.isTemplate);

    if (Array.isArray(values.attachment)) {
      values.attachment.forEach((file: any) => {
        formData.append("attachments", file);
      });
    }

    // 👇 Append cleaned question data (empty requirement / clause mappings are dropped)
    const cleanQuestion = (q: any) => ({
      ...q,
      requirementText: q.requirementText?.trim() || undefined,
      acesClauseId: q.acesClauseId ? Number(q.acesClauseId) : undefined,
    });
    formData.append("questions", JSON.stringify({
      manager: values.data.manager.map(cleanQuestion),
      employee: values.data.employee.map(cleanQuestion),
    }));

    // QualiCheck AI context
    const ctx = values.context || {};
    if (ctx.siteId) formData.append("siteId", ctx.siteId);
    if (ctx.operationalArea) formData.append("operationalArea", ctx.operationalArea);
    if (ctx.process) formData.append("process", ctx.process);
    if (ctx.temperatureMin !== "" && ctx.temperatureMin != null) formData.append("temperatureMin", String(ctx.temperatureMin));
    if (ctx.temperatureMax !== "" && ctx.temperatureMax != null) formData.append("temperatureMax", String(ctx.temperatureMax));
    formData.append("isTemperature", String(!!ctx.isTemperature));
    const shipment = {
      awb: ctx.awb, flightNo: ctx.flightNo, flightDate: ctx.flightDate || null, origin: ctx.origin,
      destination: ctx.destination, specialHandlingCodes: ctx.specialHandlingCodes, cargoDescription: ctx.cargoDescription,
    };
    if (!checklistData?.isTemplate && Object.values(shipment).some((v) => v)) formData.append("shipment", JSON.stringify(shipment));
    // A checklist created from a template keeps the link (and inherits its context defaults server-side).
    if (!checklistData?.edit && checklistData?.id && !checklistData?.isTemplate) formData.append("templateId", String(checklistData.id));

    try {
      let endpoint = "";
      let response: any = null;
      if (checklistData?.edit) {
        endpoint = Apinames.checklistUpdate;
        response = await editCheckListService(endpoint, formData);
      } else {
        endpoint = Apinames.checklistAdd;
        response = await addCheckListService(endpoint, formData);
      }
      if (response?.result) {
        setShowSuccessModal(true);
        if (checklistData?.isTemplate) {
          navigate("/templatelist");
        } else {
          navigate("/checklist");
        }
      }
    } catch (error) {
      console.log("Error in handleSubmit:", error);
      updateErrorMessage(error);
      setShowErrorModal(true);
    }
  };

  const updateErrorMessage = (error?: any) => {
    let msg = "Something went wrong.";
    if (error?.response?.data?.result) {
      msg = error.response.data.result;
    } else if (error?.response?.data?.message) {
      msg = error.response.data.message;
    } else if (error?.message) {
      msg = error.message;
    }
    setErrorMessage(msg);
  };
  return (
    <>
      <NewChecklist
        onSubmit={handleSubmit}
        defaultValues={checklistData}
        isTemplate={checklistData?.isTemplate}
        edit={checklistData?.edit}
      />
      ;{/* ✅ Success Modal */}
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Checklist Created</Modal.Title>
        </Modal.Header>
        <Modal.Body>Your checklist has been created successfully!</Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={() => setShowSuccessModal(false)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      {/* ❌ Error Modal */}
      <Modal
        show={showErrorModal}
        onHide={() => setShowErrorModal(false)}
        centered
      >
        <Modal.Header style={{ borderBottom: "unset" }} closeButton>
          <Modal.Title>{t("common.error")}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center" }}>{errorMessage}</Modal.Body>
        <Modal.Footer style={{ borderTop: "unset" }}>
          <Button
            variant="danger"
            style={{ width: "100%", borderRadius: "10px", marginTop: "unset" }}
            onClick={() => setShowErrorModal(false)}
          >
            {t("common.close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NewChecklistScreen;
